import { render, staticRenderFns } from "./AgentFactors.vue?vue&type=template&id=3a6c55a4"
import script from "./AgentFactors.vue?vue&type=script&lang=js"
export * from "./AgentFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports